import { EncounterType } from '@pm/graphql';
import { Text } from '@pm/ui';
import { Trans, useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

type AppointmentInstructionsProps = {
  encounterType: EncounterType.Phone | EncounterType.InPerson;
  brand?: string;
};

const inPersonInstructions = [
  'Instructions.InPerson.ArrivalTime',
  'Instructions.InPerson.BringHealthCareCard',
  'Instructions.InPerson.AvoidWashroom',
] as const;

const phoneInstructions = ['Instructions.Phone.WaitForCall'] as const;

type I18nKey =
  (typeof inPersonInstructions)[number] | (typeof phoneInstructions)[number];

export const AppointmentInstructions = ({
  encounterType,
  brand,
}: AppointmentInstructionsProps) => {
  const { t } = useTranslation('appointments');

  const instructions: I18nKey[] =
    encounterType === EncounterType.InPerson
      ? [...inPersonInstructions]
      : [...phoneInstructions];

  return (
    <ul
      className={twMerge(
        instructions.length > 1 &&
          'list-disc list-outside ml-xl marker:text-content-subdued',
      )}
      data-testid="appointment-instructions"
    >
      {instructions.map((i18nKey) => (
        <li key={i18nKey}>
          <Text size="bodyL" color="contentSubdued">
            <Trans
              t={t}
              ns="appointments"
              i18nKey={i18nKey}
              components={{ bold: <strong /> }}
              values={{ brand }}
            />
          </Text>
        </li>
      ))}
    </ul>
  );
};
